var NO_PROTOCOL_RESOURCE_PATTERN = /^\/\//;

function hasProtocol(uri) {
  return !NO_PROTOCOL_RESOURCE_PATTERN.test(uri);
}

module.exports = hasProtocol;



//////////////////
// WEBPACK FOOTER
// ./node_modules/clean-css/lib/utils/has-protocol.js
// module id = 99
// module chunks = 0 1